import AppsContainer from "@lib/components/AppComponents/AppsContainer";
import MessageBotTreeCanvas from "@lib/components/MiniComponents/MessageBotTree/Canvas";
import { useIntl } from "react-intl";

export default function TelegramBotConfigCanvas() {
  const { messages } = useIntl();
  // const { configId } = useParams();

  return (
    <AppsContainer
      fullView
      cardStyle={{
        background: "transparent",
        height: "100%",
        flex: 1,
      }}
      title={messages["common.settings"] as string}
    >
      <MessageBotTreeCanvas />
    </AppsContainer>
  );
}
